<template>
  <div
    class="node"
    :draggable="true"
    @dragstart="
      (e) => {
        onDragStart(e, node);
      }
    "
  >
    <div class="node-bg"></div>
    <div ref="dragGhost" class="drag-ghost">
      <img :src="node.icon" />
    </div>
    <img
      :class="[
        'node-icon',
        {
          radius: node.radius,
        },
      ]"
      :src="node.icon"
    />
    <div>
      <div :class="['title', { space: currentLocale === 'zh' }]">
        {{ node.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Node",
  components: {},
  props: {
    node: {
      type: Object,
      default: () => ({
        iconColor: "",
        description: "",
        name: "",
      }),
    },
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    onDragStart(e, node) {
      const img = new Image();
      img.src = node.icon;
      if (node.icon) {
        // 图片的大小
        e.dataTransfer.setDragImage(this.$refs.dragGhost, 24, 24);
      }
      e.dataTransfer.setData("text/plain", this.node.type);
    },
  },
};
</script>

<style lang="less" scoped>
.node {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  position: relative;
  .node-bg {
    position: absolute;
    z-index: -100;
    background: #ffffff;
  }
  .drag-ghost {
    // 设置到背后
    position: absolute;
    z-index: -1000;
    img {
      display: block;
    }
  }
  .node-icon {
    height: 48px;
    width: 48px;
    pointer-events: none;
    &.radius {
      border-radius: 100%;
    }
  }
  .title {
    pointer-events: none;
    font-size: 14px;
    padding-right: 20px;
    &.space {
      padding-right: 80px;
    }
  }
  + .node {
    margin-top: 20px;
  }
}
</style>
